// Also used on the server...
const deepValues = require('@converdy/utils/deep-values')

/*
 * 'rootId' needs to be the index of the top-most entity inside 'thingsWithSlots'
 * which you want to get the child ids for
 *
 * 'thingsWithSlots' needs to be an object of values indexed by the ids of entities
 * that are compliant with the converdy-entities-slots spec, meaning that they have
 * a slot property that describes their children nesting
 */
function getChildIds (rootId, thingsWithSlots) {
	const thingWithSlots = thingsWithSlots[rootId]

	const { slots } = thingWithSlots

	if (!slots) return []

	const directChildIds = deepValues(slots)

	const nestedChildIds = directChildIds.map(
		childId => getChildIds(childId, thingsWithSlots)
	)

	const flatNestedChildIds = nestedChildIds.flat(1)
	
	return [ ...directChildIds, ...flatNestedChildIds ]
}
 

module.exports = getChildIds
